import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';
import YearlyOutcomeTableRouter from './YearlyOutcomeTable';
import ResultSummaryRouter from './ResultSummaryCard';
import ModelYearlyChart from './ModelYearlyChart';
import ExecSummaryRouter from './ExecSummaryRouter';

const ModelTabs = ({ investorResults, borrowerResults, yearlyBreakdowns, params, selectedModel }) => {
    const allModels = Array.from(
        new Set([
            ...investorResults.map((r) => r.model),
            ...borrowerResults.map((r) => r.model),
        ])
    );

    const defaultModel = selectedModel && allModels.includes(selectedModel)
        ? selectedModel
        : allModels[0];

    const [activeTab, setActiveTab] = useState(defaultModel);

    // Sync with prop when selectedModel changes externally
    useEffect(() => {
        if (selectedModel && allModels.includes(selectedModel)) {
            setActiveTab(selectedModel);
        }
    }, [selectedModel, allModels.join(',')]); // join to watch changes properly

    const tabItems = allModels.map((model) => {
        const investor = investorResults.find((r) => r.model === model) || null;
        const borrower = borrowerResults.find((r) => r.model === model) || null;
        const yearlyData = yearlyBreakdowns[model] || [];

        return {
            key: model,
            label: model,
            children: (
                <div className="mb-6">
                    <ResultSummaryRouter modelName={model} investorResult={investor} borrowerResult={borrower} />
                    <ModelYearlyChart modelName={model} yearlyData={yearlyData} investorResult={investor} />
                    <ExecSummaryRouter modelName={model} investorResult={investor} borrowerResult={borrower} yearlyData={yearlyData} params={params} />
                    <YearlyOutcomeTableRouter modelName={model} yearlyData={yearlyData} />
                </div>
            ),
        };
    });

    return (
        <div className="mb-12">
            <Tabs
                activeKey={activeTab}
                onChange={setActiveTab}
                size="large"
                items={tabItems}
            />
        </div>
    );
};

export default ModelTabs;
